import React from "react";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function UploadImage({ styles, id, handleFileInputChange, accept, label }) {
  return (
    <div className={styles.cloud_upload_icon_container}>
      <label htmlFor={id}>
        <CloudUploadIcon
          fontSize="large"
          className={styles.cloud_upload_icon}
        />
      </label>
      {label && <span>{label}</span>}
      <input
        className={styles.upload_input}
        id={id}
        multiple
        type="file"
        name="file"
        accept={accept}
        onChange={handleFileInputChange}
      />
    </div>
  );
}
export default UploadImage;
